import React, { useState } from 'react'
import { TextField } from '@mui/material'
import { ErrorLabel } from './ShowLabel'
import { useTranslation } from 'react-i18next'

interface NewPasswordProps {
  onValidPassword: (newPassword: string | null) => void
}

const NewPassword: React.FC<NewPasswordProps> = ({ onValidPassword }) => {
  const [password, setPassword] = useState<string | undefined>(undefined)
  const [confirmPassword, setConfirmPassword] = useState<string | undefined>(undefined)
  const samePassword = password === confirmPassword
  const { t } = useTranslation('menu')

  const change = cb => event => {
    const newValue = event.target.value
    const correctPassword = newValue === password || newValue === confirmPassword
    cb(newValue)
    onValidPassword(correctPassword ? newValue : null)
  }

  return (<>
    <TextField
      label={t("newPassword")}
      margin="normal"
      variant="outlined"
      type="password"
      onChange={change(value => setPassword(value))}
      fullWidth
      size="small"
      required
    />
    <TextField
      label={t("confirmNewPassword")}
      margin="normal"
      variant="outlined"
      type="password"
      onChange={change(value => setConfirmPassword(value))}
      size="small"
      fullWidth
      required
    />
    <ErrorLabel
      show={password && confirmPassword && !samePassword}
      message={t("notMatchNewPassword")}
    />
  </>)
}
export default NewPassword